(function (root, factory) {
  var engine = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = engine;
  }
  if (root) {
    root.FFRuntimeEngine = engine;
  }
})(typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function isEmpty(value) {
    return value === undefined || value === null || (typeof value === 'string' && value.trim() === '');
  }

  function toNumber(value) {
    if (isEmpty(value) || (typeof value !== 'number' && typeof value !== 'string')) {
      return null;
    }
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function invalidResult(reasonCodes) {
    return {
      valid: false,
      runtimeHours: null,
      loadRatio: null,
      status: 'invalid',
      meetsTarget: null,
      reasonCodes: reasonCodes
    };
  }

  function calculate(model, input) {
    model = model && typeof model === 'object' ? model : {};
    input = input && typeof input === 'object' ? input : {};

    var capacityWh = toNumber(model.capacityWh);
    var acRatedW = toNumber(model.acRatedW);
    var averageW = toNumber(input.averageW);
    var runningW = toNumber(input.runningW);
    var startupKnown = !isEmpty(input.startupW);
    var startupW = startupKnown ? toNumber(input.startupW) : null;
    var targetKnown = !isEmpty(input.targetHours);
    var targetHours = targetKnown ? toNumber(input.targetHours) : null;
    var efficiencyPct = toNumber(input.efficiencyPct);
    var reservePct = toNumber(input.reservePct);
    var overheadW = toNumber(input.overheadW);
    var reasonCodes = [];

    if (capacityWh === null || capacityWh <= 0) reasonCodes.push('invalid_capacity');
    if (acRatedW === null || acRatedW <= 0) reasonCodes.push('invalid_rated_output');
    if (averageW === null || averageW <= 0) reasonCodes.push('invalid_average_load');
    if (runningW === null || runningW <= 0) reasonCodes.push('invalid_running_load');
    if (startupKnown && (startupW === null || startupW <= 0)) reasonCodes.push('invalid_startup_load');
    if (targetKnown && (targetHours === null || targetHours <= 0)) reasonCodes.push('invalid_target_hours');
    if (efficiencyPct === null || efficiencyPct <= 0 || efficiencyPct > 100) reasonCodes.push('invalid_efficiency');
    if (reservePct === null || reservePct < 0 || reservePct >= 100) reasonCodes.push('invalid_reserve');
    if (overheadW === null || overheadW < 0) reasonCodes.push('invalid_overhead');
    if (typeof input.motor !== 'boolean') reasonCodes.push('invalid_motor_flag');
    if (averageW !== null && runningW !== null && averageW > runningW) reasonCodes.push('average_exceeds_running');
    if (reasonCodes.length) return invalidResult(reasonCodes);

    var continuousLoadW = runningW + overheadW;
    var averageLoadW = averageW + overheadW;
    var startupLoadW = startupKnown ? startupW + overheadW : null;
    if (!Number.isFinite(continuousLoadW) || !Number.isFinite(averageLoadW) || (startupKnown && !Number.isFinite(startupLoadW))) {
      return invalidResult(['non_finite_load_sum']);
    }

    var loadRatio = continuousLoadW / acRatedW;
    if (!Number.isFinite(loadRatio)) return invalidResult(['non_finite_result']);

    if (continuousLoadW > acRatedW) {
      return {
        valid: true,
        runtimeHours: null,
        loadRatio: loadRatio,
        status: 'overload',
        meetsTarget: targetKnown ? false : null,
        reasonCodes: ['running_load_exceeds_rating']
      };
    }

    var runtimeHours = capacityWh * (efficiencyPct / 100) * (1 - reservePct / 100) / averageLoadW;
    if (!Number.isFinite(runtimeHours)) return invalidResult(['non_finite_result']);

    var status = 'within_rating';
    if (input.motor && !startupKnown) {
      status = 'startup_check';
      reasonCodes.push('motor_startup_unknown');
    }
    if (startupKnown && startupLoadW > acRatedW) {
      status = 'startup_check';
      reasonCodes.push('startup_load_exceeds_rating');
    }

    var meetsTarget = targetKnown ? runtimeHours >= targetHours : null;
    if (meetsTarget === false) reasonCodes.push('runtime_below_target');

    return {
      valid: true,
      runtimeHours: runtimeHours,
      loadRatio: loadRatio,
      status: status,
      meetsTarget: meetsTarget,
      reasonCodes: reasonCodes
    };
  }

  function recommend(models, input, limit) {
    if (!Array.isArray(models)) return [];
    var count = limit === undefined ? 3 : toNumber(limit);
    if (count === null || count <= 0) return [];
    count = Math.floor(count);
    var hasTarget = input && !isEmpty(input.targetHours);

    return models.map(function (model, index) {
      return { model: model, calculation: calculate(model, input), index: index };
    }).filter(function (candidate) {
      return candidate.calculation.valid && candidate.calculation.status === 'within_rating' && candidate.calculation.meetsTarget !== false;
    }).sort(function (left, right) {
      var firstField = hasTarget ? 'capacityWh' : 'acRatedW';
      var secondField = hasTarget ? 'acRatedW' : 'capacityWh';
      return toNumber(left.model[firstField]) - toNumber(right.model[firstField]) ||
        toNumber(left.model[secondField]) - toNumber(right.model[secondField]) ||
        left.index - right.index;
    }).slice(0, count).map(function (candidate) {
      return Object.assign({}, candidate.model, { calculation: candidate.calculation });
    });
  }

  return Object.freeze({ calculate: calculate, recommend: recommend });
});
